export enum GemClarity {
  EyeClean = 'Eye Clean',
  SlightlyIncluded = 'Slightly Included',
  ModeratelyIncluded = 'Moderately Included',
  VisiblyIncluded = 'Visibly Included',
}
